import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCopyright } from "@fortawesome/free-solid-svg-icons";
import '../styles/Footer.css';

const Footer = () => {
    return (
        <footer>
            <span>geomunioz </span>{' '}
            <FontAwesomeIcon icon={faCopyright}/> {' '}
            <span> 2025</span>
        </footer>
    );

}

export default Footer;